import React, { useState, useEffect } from "react";
import { Drawer, Form, Input, Button, Typography } from "antd";
import { request } from "../../../functions/request";
import { toast } from "react-toastify";

// Ficha do cliente no CARB (mesma URL usada na lista de dúvidas).
const URL_CLIENTE_CARB = "https://carb.rbvideo.com.br/sistema/cliente/";


const { TextArea } = Input;

function ModalResponderDuvida({ isOpen, onClose, duvida, onSaved }) {
  const [resposta, setResposta] = useState("");

  useEffect(() => {
    if (isOpen) {
      setResposta("");
    }
  }, [isOpen]);

  const saveData = async () => {
    if (!resposta.trim() || resposta.trim().length < 3) {
      toast.error("Digite uma resposta com no mínimo 3 caracteres!");
      return;
    }

    try {
      await request(`/duvidas/updateResposta/${duvida.duv_id}`, {
        method: "PUT",
        body: JSON.stringify({ resposta: resposta.trim() }),
      });

      toast.success("Resposta enviada com sucesso!");
      onClose();
      onSaved();
    } catch (err) {
      console.log(err);
      toast.error("Erro ao enviar resposta!");
    }
  };

  return (
    <Drawer
      title="Responder Dúvida"
      open={isOpen}
      onClose={onClose}
      width={520}
      extra={
        <Button type="primary" onClick={saveData}>
          Enviar Resposta
        </Button>
      }
    >
      <Form layout="vertical">
        {/* Saber quem pergunta e de onde muda a resposta — o analista
            costuma adequar a resposta à região de quem perguntou. */}
        <Form.Item label="Cliente">
          <a
            href={`${URL_CLIENTE_CARB}${duvida?.duv_cliente_id}`}
            target="_blank"
            rel="noopener noreferrer"
            title="Abrir o cadastro do cliente"
          >
            {duvida?.cli_nome || `Cliente ${duvida?.duv_cliente_id ?? ""}`}
          </a>
          {[duvida?.cli_cidade, duvida?.cli_estado].filter(Boolean).length > 0 && (
            <Typography.Text type="secondary" style={{ marginLeft: 8 }}>
              {[duvida?.cli_cidade, duvida?.cli_estado].filter(Boolean).join("/")}
            </Typography.Text>
          )}
        </Form.Item>
        <Form.Item label="Mercado">
          <Typography.Text>{duvida?.duv_mercado}</Typography.Text>
        </Form.Item>
        <Form.Item label="Pergunta do cliente">
          <Typography.Paragraph>{duvida?.duv_pergunta}</Typography.Paragraph>
        </Form.Item>
        <Form.Item label="Resposta">
          <TextArea
            rows={6}
            placeholder="Digite a resposta para o cliente..."
            value={resposta}
            onChange={(e) => setResposta(e.target.value)}
          />
        </Form.Item>
        <Typography.Paragraph type="secondary">
          A resposta será enviada por e-mail ao cliente e ficará disponível para leitura na página dele.
        </Typography.Paragraph>
      </Form>
    </Drawer>
  );
}

export default ModalResponderDuvida;
